import React from "react";
import PropTypes from "prop-types";
import { Link } from "gatsby";
import OutsideClickHandler from "react-outside-click-handler";
import classNames from "classnames";

import { formatPagePath } from "../../../utils";
import SVG from "../../svg";

import * as styles from "./styles.module.scss";

const ResourcesMenu = ({ cmsResourceLinks }) => {
  let resourcesLinks = cmsResourceLinks[0]?.subnav_links;

  let [open, setOpen] = React.useState(false);
  return (
    <OutsideClickHandler onOutsideClick={() => setOpen(false)}>
      <div className={classNames(`resources_menu`, styles.resources_menu)}>
        <button
          className={classNames({
            [styles.open]: open,
            [styles.closed]: !open
          })}
          onClick={() => {
            setOpen(!open);
          }}
        >
          <span>Resources</span>
          <SVG name="angle-down" />
        </button>
        <nav className={open ? styles.open : styles.closed}>
          <div className={styles.dropdown_wrapper}>
            {resourcesLinks.map((item, idx) => (
              <>
                {!item.new_window && (
                  <Link to={item.page ? formatPagePath(item.page) : item.url} key={item.id || idx}>
                    {item.link_text}
                  </Link>
                )}
                {item.new_window && (
                  <a rel="noreferrer" target="_blank" href={item.url} key={item.id}>
                    {item.link_text}
                    <span style={{ marginLeft: "3px", marginTop: "-2px" }}>
                      <SVG name="external-arrow" />
                    </span>
                  </a>
                )}
              </>
            ))}
          </div>
        </nav>
      </div>
    </OutsideClickHandler>
  );
};

ResourcesMenu.propTypes = {
  cmsResourceLinks: PropTypes.array
};

export default ResourcesMenu;
